const gradeMap = {
  Grade11: "一年级",
  Grade12: "二年级",
  Grade13: "三年级",
  Grade14: "四年级",
  Grade15: "五年级",
  Grade16: "六年级",
  Grade17: "七年级",
  Grade18: "八年级",
  Grade19: "九年级",
  Grade21: "高一",
  Grade22: "高二",
  Grade23: "高三"
};
export const convertGrades = grades => {
  return grades.map(grade => {
    return {
      label: gradeMap[grade] || grade,
      value: Number(grade.slice(-2)) // 获取 grade 的后两个字符
      // value: grade,
    };
  });
};
/**
 * 
 * @param {*} _grade 
 * @param {*} allSubjectList 
 * @returns 
 */
export const filterSubject = (_grade, allSubjectList) => {
    const grade = Number(_grade)
    let showSubjectList = []
    if (grade > 10 && grade < 17) {
      let sub = allSubjectList.filter((item) => {
        return 100 < Number(item.value) && Number(item.value) < 200
      })
      showSubjectList = sub
    }
    if (grade >= 17 && grade <= 19) {
      let sub = allSubjectList.filter((item) => {
        return (
          Number(item.value) <= 100 ||
          (Number(item.value) > 200 && Number(item.value) < 300)
        )
      })
      showSubjectList = sub
    }
    if (grade > 20 && grade < 24) {
      let sub = allSubjectList.filter((item) => {
        return Number(item.value) <= 100 || Number(item.value) > 300
      })
      showSubjectList = sub
    }
    return showSubjectList
  }


// WEBPACK FOOTER //
// ./src/utils/baseInfo.js